import {IExportExcelStylesColor} from "@containers/export/containers/excel/types";


interface IColorExcelJs{
    argb?:string
}

function convertColorToARGB(color: string): string {
    if (color.startsWith("rgba")) {
        const rgba = color.match(/[\d.]+/g);
        if (rgba) {
            const alpha = Math.round(parseFloat(rgba[3]) * 255).toString(16).toUpperCase().padStart(2, "0");
            return `${alpha}${rgba[0]}${rgba[1]}${rgba[2]}`;
        }
    }
    if (color.startsWith("rgb")) {
        const rgb = color.match(/[\d]+/g);
        if (rgb) {
            return `FF${parseInt(rgb[0]).toString(16).toUpperCase().padStart(2, "0")}${parseInt(rgb[1]).toString(16).toUpperCase().padStart(2, "0")}${parseInt(rgb[2]).toString(16).toUpperCase().padStart(2, "0")}`;
        }
    }
    if (color.startsWith("#")) {
        if (color.length === 4) {
            const hex = color.slice(1);
            return `${hex[3]}${hex[0]}${hex[1]}${hex[2]}`;
        } else if (color.length === 7) {
            return `FF${color.slice(1)}`;
        }
    }
    return "";
}
export const mutateColorToExcelJsFormat = (color:IExportExcelStylesColor):IColorExcelJs | undefined=>{
    if(!color?.rgb){
        return
    }

    return {
        argb:convertColorToARGB(color.rgb)
    }
}